import { render, staticRenderFns } from "./CardUserPerfil.vue?vue&type=template&id=0a0df98f"
import script from "./CardUserPerfil.vue?vue&type=script&lang=js"
export * from "./CardUserPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports